/* Funções puras que leem o catálogo de tipos/etapas já carregado (ver
   services/processoTipos.js) -- substituem o antigo etapasConfig.js, que
   guardava esse conteúdo fixo direto no código. Toda função aqui recebe o
   array `catalogo` (resultado de carregarCatalogo()) como primeiro
   argumento, já que agora ele vem de uma chamada assíncrona à API. */

export function tipoPorChave(catalogo, chave) {
  return (catalogo || []).find(t => t.chave === chave) || null;
}

/* só as etapas ativas, na ordem -- é o que importa pro fluxo operacional
   (checklist do processo); a tela de gestão usa o tipo inteiro (com
   etapas inativas também) direto do catálogo, sem passar por aqui */
export function etapasDoTipo(catalogo, chave) {
  return (tipoPorChave(catalogo, chave)?.etapas || [])
    .filter(e => e.ativo)
    .sort((a, b) => a.ordem - b.ordem);
}

export function etapaPorNumero(catalogo, chave, numero) {
  return etapasDoTipo(catalogo, chave)[numero - 1] || null;
}

export function nomeEtapa(catalogo, chave, numero) {
  return etapaPorNumero(catalogo, chave, numero)?.nome || `Etapa ${numero}`;
}

export function totalEtapas(catalogo, chave) {
  return etapasDoTipo(catalogo, chave).length;
}

export function labelTipo(catalogo, chave) {
  return tipoPorChave(catalogo, chave)?.nome || chave;
}

/* só tipos ativos e com pelo menos uma etapa ativa podem ser escolhidos
   ao criar um processo novo */
export function tiposDisponiveis(catalogo) {
  return (catalogo || []).filter(t => t.ativo && etapasDoTipo(catalogo, t.chave).length > 0);
}

export const STATUS_PROCESSO = [
  { valor: 'em_andamento', label: 'Em andamento' },
  { valor: 'concluido',    label: 'Concluído' },
  { valor: 'cancelado',    label: 'Cancelado' },
  { valor: 'travado',      label: 'Travado' },
];

export function labelStatus(valor) {
  return STATUS_PROCESSO.find(s => s.valor === valor)?.label || valor;
}
